import React from "react";
import styled from "@emotion/styled";
import {
  Box,
  IconButton,
  InputBase,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../../theme";
import ProfileLayout from "../global/ProfileLayout";
import { TokensTable } from "../global/TokensTable";
import { searchIcon } from "../../assets";
import { useWeb3React } from "@web3-react/core";

const RowWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: "15px",
  width: "98%",
  minHeight: "180px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  margin: "0px auto",
  marginBottom: "30px",
  paddingBottom: "30px",
  // margin: "20px",
}));

const HeaderRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "98%",
});

const Tokens = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { account } = useWeb3React();

  return (
    <ProfileLayout
      collectionCount={false}
      nftCount={false}
      layoutType={"tokens"}
    >
      <Stack
        direction="column"
        width="100%"
        marginTop="30px"
        display="flex"
        alignItems={"center"}
        justifyContent="center"
      >
        <Box
          display="flex"
          backgroundColor={theme.palette.secondary.dark}
          borderRadius="6px"
          flex={8}
          sx={{
            border: "1px solid #F3F5F9",
            width: "98%",
            marginBottom: "20px",
          }}
        >
          <IconButton type="button" sx={{ p: 1 }}>
            <img src={searchIcon} alt="search" />
          </IconButton>
          <InputBase
            sx={{ ml: 2, flex: 1, fontSize: "14px" }}
            placeholder="Search By Token"
            value={""}
            onChange={(e) => console.log("e")}
          />
        </Box>

        <RowWrapper>
          <HeaderRow>
            <Typography
              variant="subtitle2"
              fontWeight="500"
              color={colors.black[900]}
            >
              {account || ""}
            </Typography>
          </HeaderRow>
          <TokensTable tokensPage />
        </RowWrapper>
      </Stack>
    </ProfileLayout>
  );
};

export default Tokens;
